const doc = [({"en":({"js":({"admin":({"bundles":({"show":({"show_bundle_name":"Show bundle: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;